var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content px-0 mx-0",staticStyle:{"margin":"0px"}},[_c('SelectEvents')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }